import $ from 'jquery';

// @types/select2 を使いたいが @types/jquery に依存していて、 @types/jquery が jquery 3.x 用なので
// jquery をアップデートするまでは必要な部分を抜き出して使う。
// https://github.com/DefinitelyTyped/DefinitelyTyped/blob/master/types/select2/index.d.ts

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace Select2 {
  export interface QueryOptions {
    term?: string | undefined;
    page?: number | undefined;
  }
  export interface TranslationArg {
    input: string;
    minimum: number;
    maximum: number;
  }
  export interface OptionData {
    disabled: boolean;
    element: HTMLOptionElement;
    id: string;
    selected: boolean;
    text: string;
    title: string;

    loading?: undefined;
    children?: undefined;
  }
}

type CompanyQueryParam = {
  keyword: string;
  with_unpublished?: boolean;
};

type videoBundleCompanyQueryParam = {
  company_ids: string;
  keyword: string;
};

type CompanyQueryResult = {
  companies: { id: number; name: string }[];
};

type VideoChaptersResult = {
  video_chapters: { id: number; title: string }[];
};

const select2 = (elem: HTMLElement | string) => {
  const $elem = $(elem);
  const maxSelection = $elem.data('maxSelection');
  const options = {
    width: '100%',
    language: {
      noResults: () => '候補が見つかりません',
      maximumSelected: (args: Select2.TranslationArg) => `${args.maximum}件しか選択できません`,
    },
    maximumSelectionLength: maxSelection ?? undefined,
  };
  $elem.select2(options);
};
const select2Company = (elem: HTMLElement | string) => {
  const $elem = $(elem);
  const withUnpublished = $elem.data('withUnpublished');
  $elem.select2({
    debug: true,
    minimumInputLength: 1,
    width: '100%',
    language: {
      noResults: () => '候補が見つかりません',
      searching: () => '検索中...',
      inputTooShort: (args: Select2.TranslationArg) => `${args.minimum}文字以上入力してください`,
      errorLoading: () => '読み込みに失敗しました。入力し直してください。',
    },
    ajax: {
      delay: 250,
      url: $elem.data('url'),
      data(params: Select2.QueryOptions) {
        const opts: CompanyQueryParam = {
          keyword: params.term!, // ここで params.term が undefined になることはなさそう
        };
        if (withUnpublished) {
          opts.with_unpublished = true;
        }
        return opts;
      },
      processResults(data: CompanyQueryResult, _params: Select2.QueryOptions) {
        return { results: data.companies };
      },
    },
  });
};

const select2PromotionContract = (elem: HTMLElement | string) => {
  const $elem = $(elem);
  $elem.select2({
    debug: true,
    width: '100%',
    language: {
      noResults: () => '候補が見つかりません'
    },
  });
};

const select2VideoChapter = (elem: HTMLElement | string) => {
  const $elem = $(elem);
  $elem.select2({
    debug: true,
    width: '100%',
    language: {
      noResults: () => '候補が見つかりません',
      searching: () => '検索中...',
      errorLoading: () => '読み込みに失敗しました。入力し直してください。',
    },
    ajax: {
      delay: 250,
      url: $elem.data('url'),
      data(params: Select2.QueryOptions) {
        const opts: videoBundleCompanyQueryParam = {
          company_ids: $elem.attr('data-company-ids'),
          keyword: params.term!,
        };
        return opts;
      },
      processResults(data: VideoChaptersResult) {
        return { results: data.video_chapters };
      },
    },
  });
};

window.OC ||= {};
window.OC.select2 = select2;

$(document).on('nested:fieldAdded', (e: any) => {
  e.field.find('.js-search-select').each((_: number, elem: HTMLElement) => select2(elem));
  e.field.find('.js-search-select-company').each((_: number, elem: HTMLElement) => select2Company(elem));
  e.field.find('.js-search-select-promotion-contract').each((_: number, elem: HTMLElement) => select2PromotionContract(elem));
  e.field.find('.js-search-select-video-chapter').each((_: number, elem: HTMLElement) => select2VideoChapter(elem));
});

window.addEventListener('DOMContentLoaded', () => {
  select2('.js-search-select');
  select2Company('.js-search-select-company');
  select2PromotionContract('.js-search-select-promotion-contract');
  select2VideoChapter('.js-search-select-video-chapter');
});
